import { useEffect, useState } from "react";

function diff(target) {
  const now = new Date();
  const t = new Date(target);
  if (!target || isNaN(t.getTime())) return { d: 0, h: 0, m: 0, s: 0, done: false };
  let s = Math.max(0, Math.floor((t - now) / 1000));
  const d = Math.floor(s / 86400); s -= d * 86400;
  const h = Math.floor(s / 3600); s -= h * 3600;
  const m = Math.floor(s / 60); s -= m * 60;
  return { d, h, m, s, done: t - now <= 0 };
}

export function Countdown({ target, open }) {
  const [t, setT] = useState(diff(target));
  useEffect(() => {
    setT(diff(target));
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (open === false) {
    return (
      <div data-testid="countdown-closed" className="w-full bg-brand-alert text-white text-center py-3 px-4 text-sm sm:text-base font-semibold">
        Commandes closes — contactez-nous au 07 60 00 10 96
      </div>
    );
  }

  const cell = (val, label) => (
    <div className="flex flex-col items-center min-w-[52px] sm:min-w-[74px]">
      <span className="num text-3xl sm:text-5xl text-brand-gold leading-none">
        {String(val).padStart(2, "0")}
      </span>
      <span className="text-[10px] sm:text-xs uppercase tracking-widest text-white/60 mt-1">{label}</span>
    </div>
  );

  return (
    <div data-testid="countdown-banner" className="w-full bg-brand-green text-white py-4 px-4">
      <div className="brand-container flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8">
        <p className="festive text-5xl sm:text-6xl text-brand-gold text-center sm:text-left leading-none">
          Souccot arrive dans
        </p>
        <div className="flex items-center gap-3 sm:gap-5">
          {cell(t.d, "jours")}
          <span className="text-brand-gold/40 text-2xl sm:text-4xl -mt-3">:</span>
          {cell(t.h, "heures")}
          <span className="text-brand-gold/40 text-2xl sm:text-4xl -mt-3">:</span>
          {cell(t.m, "min")}
          <span className="text-brand-gold/40 text-2xl sm:text-4xl -mt-3">:</span>
          {cell(t.s, "sec")}
        </div>
      </div>
    </div>
  );
}
